import React, { useEffect } from "react";
import { Line } from "rc-progress";
import PropTypes from "prop-types";
import { useAuth } from "../../components/AuthContext/AuthContext";

const StepProgressBar = ({
  steps,
  currentStep,
  isCompleted,
  is_assessment_completed,
}) => {
  const auth = useAuth();
  const calculateProgressPercentage = () => {
    if (steps <= 1) return 0;
    return (currentStep / steps) * 100; 
  };
  const progressPercentage = calculateProgressPercentage();

  useEffect(() => {
    if (is_assessment_completed) {
      auth.setIsCompleted(true);
    }
  }, [is_assessment_completed, isCompleted]);

  return (
    <div
      className="progress-bar-container"
      data-testid="progress-bar"
      name="progress-bar"
    >
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${progressPercentage}%` }} />
      </div>
      <div className="progress-label ageo-medium">
        STEP {currentStep} OF {steps}
      </div>
    </div>
  );
};

StepProgressBar.propTypes = {
  steps: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  completedSteps: PropTypes.number.isRequired,
  is_assessment_completed: PropTypes.bool.isRequired,
};

export default StepProgressBar;
